/* eslint-disable spaced-comment */

import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);
import axiosAuth from '../axios-auth';
import axios from 'axios';
import router from '../router/AllRoutes';
//import { stat } from 'fs';
export const store = new Vuex.Store({
  state:
  {
    ServiceID: null,
    Mainmenu: "",
    RefreshToken: null,
    AccessToken:null,
    UserID : null,
    
    BuildMenu:false,
    menuToggle:false,
    DentalServiceID:1,
    MedicalServiceID:2,
    OpticalServiceID:3,
    HearingServiceID:4,
    PodiatryServiceID:5,
    DefaultServiceID:0,
    DPEBBServiceID:6,
    FHServiceID:7,
    faq: "/faq",
    ContactUs: "/ContactUs",
    PWDminLen: 12,
    ReturnUrl: "",
    AllApplevel:false,
    DateFormat:'yyyy/MM/dd',
    message:'',
    ShowLoginMsg:false
    },
    mutations: {
        SetMainMenu(state,payload) {
            //alert(payload)
            store.state.Mainmenu = payload;
        },
        SetServiceID(state,payload) {
            //alert(payload)
            store.state.ServiceID = payload;
        },
        SetAllApplevel(state,payload) {
            var s = payload.toUpperCase();
            if(s == "TRUE")
            {
                store.state.AllApplevel = true;    
            }
            if(s == "FALSE")
            {
                store.state.AllApplevel = false;
            }
            
        },
        SetToggle(state,payload) {
            //alert(payload)
            store.state.menuToggle = payload;
        },
        BuildMainMenu(state,payload) {

            store.state.BuildMenu = payload;
        },
        AuthUser(state, payload) {
            //alert(payload.AccessToken)
            // store.state.IsAuth = payload.IsAuth;
            store.state.AccessToken = payload.AccessToken;
            store.state.UserID = payload.userName;
        },
        SetUser(state, payload) {
            //alert(payload)
            store.state.UserID = payload;
        },
        SetToken(state, payload) {
            //alert(payload)
            store.state.RefreshToken = payload;
        },
        SetAccessToken(state, payload) {
            //alert(payload)
            store.state.AccessToken = payload;
        },
        EmptyMainMenu(state) {
            //alert(payload)
            store.state.Mainmenu="";
        },
        SetLogout(state) {
            //alert(payload)
            store.state.AccessToken=null;
            store.state.UserID=null;
            store.state.Mainmenu=null;
            localStorage.clear();
           // router.push("home");
            router.push({ name: 'home'});
        },
        SetLoginMsg(state) {
            //alert(payload)
            store.state.ShowLoginMsg=false; 
        },
    },
    getters: {
        GetServiceID(state) {
            if (state.ServiceID !=null)
            return state.ServiceID;
            else
            return false;
        },
        GetAboutusLink(state) {
            return state.about;
        },
        GetAllApplevel(state) {
            return state.AllApplevel;
        },
        GetContactUsLink(state) {
            return state.contact;
        },
        GetDefaultServiceID(state) {
            return state.DefaultServiceID;
        },
        GetFHServiceID(state) {
            return state.FHServiceID;
        },
        GetDPEBBServiceID(state) {
            return state.DPEBBServiceID;
        },
        GetDentalID(state) {
            return state.DentalServiceID;
        },
        GetMedicalID(state) {
            return state.MedicalServiceID;
        },
        GetOpticalID(state) {
            return state.OpticalServiceID;
        },
        GetHearingID(state) {
            return state.HearingServiceID;
        },
        GetPodiatryID(state) {
            return state.PodiatryServiceID;
        },
        GetMainMenu(state) {
            return state.Mainmenu;
        },
        GetToggle(state) {
            //alert(payload)
           return state.menuToggle;
        },
        GetuildMainMenu(state) {
            return state.BuildMenu;
        },
        IsAuth(state) {
            return state.AccessToken !== null;
        },
        GetCurrentUser(state) {
            //alert(state.UserID)
            return state.UserID;
        },
        GetRefreshToken(state) {
            return state.RefreshToken;
        },
        GetAccessToken(state) {
            return state.AccessToken;
        },
        MainMenuLength(state) {
            if(state.Mainmenu == null)
            return 0;
            else
            return state.Mainmenu.length;
        },
        GetPwdMinLength(state){
            return state.PWDminLen;
        },
        GetReturnUrl(state){
            return state.ReturnUrl;
        },
        GetDateFormat(state){
            return state.DateFormat;
        },
        GetMessage(state) {
            return state.message;
        },
        ShowLoginMsg(state) {
            return state.ShowLoginMsg;
        },
    },
    actions: {
        Login({commit,dispatch}, params){
            var vm = this;
            //axiosAuth.post('/AuthenticateUser', params, { headers: { "Access-Control-Allow-Origin": "*"},}).then(function (response) {
                axiosAuth.post('/AuthenticateUser', params).then(function (response) { 
                // ////console.log(response)
             
               // ////console.log(response.data.access_token);
                //localStorage.isAuth = true;
                //localStorage.refresh_token = response.data.refresh_token;
                //localStorage.ServiceUrl =   response.data.ReturnUrl;
                //localStorage.access_token = response.data.access_token;
                const nowDate = new Date();
                const expirationDate = new Date(nowDate.getTime()+response.data.expires_in*1000);
                //////console.log(expirationDate)
                localStorage.setItem('access_token',response.data.access_token);
                localStorage.setItem('UserID',response.data.userName);
                 
                localStorage.setItem('ExpirationDate',expirationDate);
                dispatch('EmptyMenu');
               // vm.$router.push({ path: localStorage.ServiceUrl });
                store.commit('AuthUser', {AccessToken:response.data.access_token,userName:response.data.userName});
                //dispatch('GetMenuItems', 1);
                store.commit('SetAllApplevel',response.data.AppLevel);
                dispatch('setLogoutTimer', response.data.expires_in);
              // dispatch('updatepwd');
                //router.push({ path: response.data.ReturnUrl });
                //router.push({ path: '/DPEBB/ManageUser' });
                //alert(response.data.upd);
                store.state.message = '';
                //router.push({ path:  '/components/FieldHospitalDashboard'});
                if(response.data.upd == "True"){
                    store.state.message = '';
                    store.state.ReturnUrl = response.data.ReturnUrl;
                    router.push({path: '/UpdatePassword'});
                  }
                else{
                    store.state.message = '';
                    //router.push("FieldDash")
                    router.push(response.data.ReturnUrl, () => {
                        
                    })
                    //router.push({ path: response.data.ReturnUrl}); // FieldDash
                    //router.push({ name:  'FieldDash'});
                } 
            })
            .catch(function (er) {
                 ////console.log(er);
                if(er.response.status == 400){
                    store.state.message = er.response.data.error_description;
                    store.state.ShowLoginMsg=true;
                   // vm.$root.$emit('LoginError', er.response.data.error_description);
                    //////console.log(er.response.data.error_description);
                   //  router.push({ name: 'Login', params: {Error: er.response.data.error_description}});
                } 
            });
        },

        AutoLogin({commit}){
            const token = localStorage.getItem('access_token');
            if(!token)
            {
                return;
            }
            const expireIn =  localStorage.getItem('ExpirationDate');
            const UserID =  localStorage.getItem('UserID');
             
            const now = new Date();
            if(now>= expireIn)
            {
                return;
            }
            commit('AuthUser', {AccessToken:token,userName: UserID});

        },
        GetMenuItems({commit,state,dispatch},ServiceID){
            var vm = this;
            //var ServiceID=0;
            dispatch('EmptyMenu');
            //alert('at get menu')
           // alert(ServiceID)
           //////console.log('at menu created');
          // ////console.log(store.state.AccessToken);
            var params = new URLSearchParams();
            params.append("_", Date.now()); 
             params.append('ServiceID', ServiceID);
             axios.get('SaskHealthApi/security/GetUserPages', { headers: { 'Authorization': 'Bearer ' + store.state.AccessToken },params})
            .then(function (response) {
                dispatch('loadItems',response.data);
                //////console.log(response.data);
                //showbar = true;
                 //router.push({ path: params });
            })
            .catch(function (er) {
                ////console.log(er);
                if (er.status === 401) {
                    ////console.log('unauthorized, logging out ...');
                    dispatch('Logout');
                    //////console.log(auth);
                    //auth.logout();
                    //router.replace('/');
                }
            });
        },

        updatepwd (context, state) {
            var vm = this;
           // ////console.log(store.state.AccessToken);
            var params = new URLSearchParams();
             params.append('UserName', 'ServiceID');
              params.append('Password', 'ServiceID');
               params.append('ConfirmPassword', 'ServiceID');
                params.append('ClinicNo', 'ServiceID');
                //axios.get('SaskHealthApi/security/UpdatePassword', { headers: { 'Authorization': 'Bearer ' + store.state.AccessToken},data: params})
            axios.get('/SaskHealthApi/security/UpdatePassword', { headers: { 'Authorization': 'Bearer ' + store.state.AccessToken, 'Content-Type': 'application/x-www-form-urlencoded' },params})
            .then(function (response) {

                 ////console.log(response.data);

            })
            .catch(function (er) {
                ////console.log(er);
            });
        },

        loadItems (context, items) {
            //alert('at load')
            //alert(items)
            //////console.log(items);
            context.commit("SetMainMenu", items);
            context.dispatch('SetBuildMenu');
        },
        ResetLoginMSg (context, items) {
            context.commit('SetLoginMsg');
        },
        AddServiceID (context, payload) {
            context.commit("SetServiceID", payload);
        },
        ChangeToggle (context, payload) {
            context.commit("SetToggle", payload);
        },
        SetBuildMenu (context) {
            //alert(items)
            //////console.log(items)
            context.commit("BuildMainMenu", true);
        },
        Logout (context) {
            //alert(items)
            //////console.log(items)
            localStorage.clear();
            localStorage.removeItem('access_token');
            localStorage.removeItem('ExpirationDate');
            localStorage.removeItem('UserID');
            context.commit("SetLogout");
            //router.push('home');
        },
        setLogoutTimer({commit},expirationTime){
                setTimeout(function (){
                        commit('SetLogout');
                },expirationTime*1000);
            // },expirationTime);
        },
        SetRefreshToken (context, payload) {
            context.commit("SetToken", payload);
        },
        SetAccessToken (context, payload) {
            context.commit("SetAccessToken", payload);
        },
        EmptyMenu (context) {
            context.commit("EmptyMainMenu");
        },
        SetMainMenuAsync (context, payload) {
            //alert(context)
            //alert(payload)
            setTimeout(function (payload) {
                context.commit('SetMainMenu', payload);
            }, 1000);
        }
    }
});
